const SgiFormEditorEO = function () {
    return {
        alwBlk: true,
        // c:"attribute1",
        ctlH: 0,
        // ctlN:"弹出窗",
        ctlW: 24,
        desId: "EP_EO_UI_3012",
        isDis: false,
        isHdn: false,
        isLbl: false,
        isRead: false,
        lblAlg: "right",
        lblW: 3,

        maxL: 0,
        minL: 0,
        // n:"属性1",
        sNo: 0,
        // t:"umeditor",
        te: "富文本",
        // useTim:0,
        visible: true,
        // x:"0",
        // y:"0",
    }
}

export { SgiFormEditorEO };
export default SgiFormEditorEO;



// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiFormEditorEO.js